import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { AlertModal, Heading, Para, Stack } from 'ui-components';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function ConvertConfirmation({
  open,
  onClose,
  onConfirm,
}: Props): React.ReactElement {
  return (
    <AlertModal
      open={open}
      title={
        <Stack direction="row" gap={2} className="items-center justify-center">
          <Heading variant="h3">Pre Booking</Heading>
          <ArrowRightIcon className="size-8" />
          <Heading variant="h3">Buchung</Heading>
        </Stack>
      }
      onClose={onClose}
      onConfirm={onConfirm}
      yesButtonLabel="Bestätigen"
      noButtonLabel="Cancel"
    >
      <Stack gap={3} className="text-pretty">
        <Para size="base">
          Wenn Du ein Pre-Booking in eine Buchung umwandelst wird der Kunde direkt in die
          Wareschlange (Ende) aufgenommen, wie bei einer normalen Buchung
        </Para>

        <Para size="base">
          Dieser Schritt kann nicht rückgängig gemacht werden. Bitte nur durchführen, Wenn der Kunde
          effektiv im Salon ist und in die Schlange aufgenommen werden möchte.
        </Para>
      </Stack>
    </AlertModal>
  );
}
